import { Component, OnInit } from '@angular/core';
import { Order } from '../../models/order';
import { OrderStateService } from '../../services/order-state.service';

@Component({
  selector: 'app-current-basket-view',
  templateUrl: './current-basket-view.component.html',
  styleUrls: ['./current-basket-view.component.css']
})

export class CurrentBasketViewComponent implements OnInit {

  order: Order;

  constructor(
    private orderStateService: OrderStateService,
  ) {
  }

  ngOnInit() {
    this.order = this.orderStateService.order;
  }
}
